import React from 'react'

const Reminder = ({
  fill = '#2D54E8',
  width = '24',
  height = '24'
}: {
  fill?: string
  width?: string
  height?: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Reminder Hand</title>
      <path
        d="M6.5 8H7.5V7C7.5 6.71667 7.40417 6.47917 7.2125 6.2875C7.02083 6.09583 6.78333 6 6.5 6C6.21667 6 5.97917 6.09583 5.7875 6.2875C5.59583 6.47917 5.5 6.71667 5.5 7C5.5 7.28333 5.59583 7.52083 5.7875 7.7125C5.97917 7.90417 6.21667 8 6.5 8ZM11 8C11.2833 8 11.5208 7.90417 11.7125 7.7125C11.9042 7.52083 12 7.28333 12 7C12 6.71667 11.9042 6.47917 11.7125 6.2875C11.5208 6.09583 11.2833 6 11 6C10.7167 6 10.4792 6.09583 10.2875 6.2875C10.0958 6.47917 10 6.71667 10 7V8H11ZM10.475 22C10.0083 22 9.57083 21.9 9.1625 21.7C8.75417 21.5 8.40833 21.2167 8.125 20.85L2.675 13.925L3.15 13.425C3.48333 13.075 3.88333 12.8667 4.35 12.8C4.81667 12.7333 5.25 12.825 5.65 13.075L7.5 14.2V10H6.5C5.66667 10 4.95833 9.70833 4.375 9.125C3.79167 8.54167 3.5 7.83333 3.5 7C3.5 6.16667 3.79167 5.45833 4.375 4.875C4.95833 4.29167 5.66667 4 6.5 4C6.68333 4 6.85417 4.01667 7.0125 4.05C7.17083 4.08333 7.33333 4.125 7.5 4.175V3C7.5 2.71667 7.59583 2.47917 7.7875 2.2875C7.97917 2.09583 8.21667 2 8.5 2C8.78333 2 9.025 2.09583 9.225 2.2875C9.425 2.47917 9.525 2.71667 9.525 3V4.4C9.75833 4.26667 9.99583 4.16667 10.2375 4.1C10.4792 4.03333 10.7333 4 11 4C11.8333 4 12.5417 4.29167 13.125 4.875C13.7083 5.45833 14 6.16667 14 7C14 7.83333 13.7083 8.54167 13.125 9.125C12.5417 9.70833 11.8333 10 11 10H9.525V17.8L7.1 16.3L9.7 19.625C9.8 19.7417 9.91667 19.8333 10.05 19.9C10.1833 19.9667 10.325 20 10.475 20H16C16.55 20 17.0208 19.8042 17.4125 19.4125C17.8042 19.0208 18 18.55 18 18V14C18 13.7167 17.9042 13.4792 17.7125 13.2875C17.5208 13.0958 17.2833 13 17 13H11.525V11H17C17.8333 11 18.5417 11.2917 19.125 11.875C19.7083 12.4583 20 13.1667 20 14V18C20 19.1 19.6083 20.0417 18.825 20.825C18.0417 21.6083 17.1 22 16 22H10.475Z"
        fill={fill}
      />
    </svg>
  )
}

export default Reminder
